import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField } from '@mui/material';
import React, { Component } from 'react';
import Global from '../../../customlib/Global';

class AnalyseDataCancelDialog extends Component {
    state = { 
        data: null
    }
    
    componentDidMount() {
        this.setState({data: this.props.selectedData ? {...this.props.selectedData} : null});
    }

    handleGroupReasonChange = (event) => {
        const obData = {...this.state.data};
        obData.groupReason = event.target.value;
        obData.reason = "";
        this.setState({ data: obData});
    }
    
    handleReasonChange = (event) => {
        const obData = {...this.state.data};
        obData.reason = event.target.value;
        this.setState({ data: obData});
    }

    handleDataChange = (event, field) => {
        const obData = {...this.state.data};
        obData[field] = event.target.value;
        this.setState({data: obData});
    }

    render() { 

        // if(!this.state.data && this.props.isDialogOpen){
        //     return (
        //         <Dialog open={this.props.isDialogOpen ?? false} onClose={this.props.onClose}>
        //             <DialogTitle>Invalid Data</DialogTitle>
        //             <DialogContent>
        //                 <DialogContentText>
        //                     Customer belum dipilih
        //                 </DialogContentText>
        //             </DialogContent>
        //         </Dialog>
        //     );
        // }

        return (
            <Dialog open={this.props.isDialogOpen ?? false} onClose={this.props.onClose}>
                <DialogTitle>
                    Analisa Data Cancel
                    <Divider />
                    {
                        this.props.isLoadingAnalisa && <LinearProgress />
                    }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        
                    </DialogContentText>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>Nama : {this.state.data?.fromName}</Grid>
                        <Grid item xs={6}>Nomor : {this.state.data?.from}</Grid>
                        <Grid item xs={6}>Kategori Produk : {this.state.data?.productCategory}</Grid>
                        <Grid item xs={6}>Kota : {this.state.data?.cityName}</Grid>
                    </Grid>
                    {
                        this.props.errorMessage !== "" && <Alert sx={{mt: "10px"}} severity="error">{this.props.errorMessage}</Alert>
                    }
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <FormControl sx={{mt: "20px"}} size="small" variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                                <InputLabel id="cb-group-reason">Pilih Group Alasan</InputLabel>
                                <Select
                                labelId="cb-group-reason"
                                id="cb-group-reason"
                                defaultValue={this.state.data?.groupReason}
                                value={this.state.data?.groupReason}
                                onChange={this.handleGroupReasonChange}
                                label="Group Alasan"
                                >
                                {
                                    Global.treeReasonCancel.map(
                                    (cat) => {
                                        return (<MenuItem key={cat.group.toLowerCase()} value={cat.group}>{cat.group}</MenuItem>);
                                    } 
                                    )
                                }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl sx={{mt: "20px", mb: "20px"}} size="small" variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                                <InputLabel id="cb-reason">Pilih Alasan</InputLabel>
                                <Select
                                labelId="cb-reason"
                                id="cb-reason"
                                value={this.state.data?.reason}
                                onChange={this.handleReasonChange}
                                label="Alasan"
                                >
                                {
                                    this.state.data?.groupReason && this.state.data?.groupReason.length > 0 && Global.treeReasonCancel.find(item => item.group === this.state.data?.groupReason)?.reasons?.map(
                                    (cat) => {
                                        return (<MenuItem key={cat.toLowerCase()} value={cat}>{cat}</MenuItem>);
                                    } 
                                    )
                                }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField value={this.state.data?.why1} onChange={(event) => this.handleDataChange(event, "why1")} id="txt_why1" label="Why 1" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField value={this.state.data?.why2} onChange={(event) => this.handleDataChange(event, "why2")} id="txt_why2" label="Why 2" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField value={this.state.data?.why3} onChange={(event) => this.handleDataChange(event, "why3")} id="txt_why3" label="Why 3" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField value={this.state.data?.why4} onChange={(event) => this.handleDataChange(event, "why4")} id="txt_why4" label="Why 4" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField value={this.state.data?.why5} onChange={(event) => this.handleDataChange(event, "why5")} id="txt_why5" label="Why 5" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField value={this.state.data?.feedback} onChange={(event) => this.handleDataChange(event, "feedback")} id="txt_feedback" label="Feedback/Solusi" variant="outlined" fullWidth size='small' />
                        </Grid>
                    </Grid>
                    <Divider />
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='warning' onClick={this.props.onClose} sx={{textTransform: "capitalize"}}>Batal</Button>
                    <Button variant='contained' color={"primary"} disabled={this.props.isSubmiting} onClick={() => this.props.onSubmit(this.state.data)} sx={{textTransform: "capitalize"}}>
                        Simpan
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
 
export default AnalyseDataCancelDialog;